/* eslint-disable no-unused-vars */
import DatePicker, { registerLocale } from 'react-datepicker'
import { targetLang } from '../../../lib/booking-localization'
import React, { FC, forwardRef, useState } from 'react'
import BookingCalendarHeader from './BookingCalendarHeader'

import ru from 'date-fns/locale/ru'
import en from 'date-fns/locale/en-GB'
import s from './BookingCalendar.module.sass'

import IconCalendar from '@icons/icon-calendar.svg'
import { TypeExtendedScheduleDay } from '@shared/types/schedule/types'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { TypeMappingScheduleWeek } from '@shared/api/middleware/mappingAPI/restaurant/type'

// from react-datepicker
registerLocale('ru', ru)
registerLocale('en', en)

interface Props {
  selectedDate: TypeExtendedScheduleDay | null
  calendarTarget: boolean
  allDatesEnabled: boolean
  schedule: TypeMappingScheduleWeek | null
  handleChangeDate: (selectedDate: Date) => void
  handleCalendarOpened?: (value: boolean) => void
}

const BookingCalendar: FC<Props> = ({
  selectedDate,
  calendarTarget,
  schedule,
  allDatesEnabled,
  handleChangeDate,
  handleCalendarOpened,
}) => {
  const { isDesktop, isMobile } = useClientResponsive()
  const [isCalendarOpened, setIsCalendarOpened] = useState(false)

  const handleOpenCalendar = () => {
    setIsCalendarOpened(true)
    handleCalendarOpened && handleCalendarOpened(true)
  }
  const handleCloseCalendar = () => {
    setIsCalendarOpened(false)
    handleCalendarOpened && handleCalendarOpened(false)
  }

  // кнопка для открытия календаря
  // @ts-ignore
  const CalendarButtonInput = forwardRef(function CalendarButtonInput({ value, onClick }, ref) {
    let calendarButtonClassname = ` ${s.button} ${
      (!isMobile && isCalendarOpened) || calendarTarget ? s['button--red'] : ''
    } `
    if (selectedDate?.itemTextShort || selectedDate?.value) {
      calendarButtonClassname += `${s['button--day']}`
    } else {
      calendarButtonClassname += `${s['button--icon']}`
    }

    return (
      // @ts-ignore
      <button className={calendarButtonClassname} onClick={onClick} ref={ref} type='button'>
        <span className={s['button-text']}>
          {isDesktop && (selectedDate?.itemTextShort || selectedDate?.value) ? (
            <>
              <IconCalendar />
              {selectedDate?.itemTextShort ||
                (selectedDate?.value ? new Date(selectedDate.value).toLocaleDateString() : '')}
            </>
          ) : (
            <IconCalendar />
          )}
        </span>
      </button>
    )
  })

  // кнопки дат + задание стилей для выходного дня и обычного
  const CalendarDayContent = (day: number, date: Date) => {
    const weekEndClassName = date.getDay() === 0 || date.getDay() === 6 ? 'react-datepicker__day-weekend' : ''
    return <span className={weekEndClassName}>{day}</span>
  }

  const scheduleCalendarFilter = (date: Date) => {
    if (allDatesEnabled) return true
    if (!schedule) return
    const isOpened = !!schedule[date.getDay()].open
    return isOpened
  }

  const handleChangeCalendar = (selectedDate: Date) => {
    handleChangeDate(selectedDate)
  }

  return (
    <ErrorBoundary>
      {isMobile && isCalendarOpened && <CalendarButtonInput />}
      <div className={`${s.wrapper} ${isCalendarOpened ? s.opened : ''}`}>
        <DatePicker
          customInput={<CalendarButtonInput />}
          selected={selectedDate ? new Date(selectedDate?.thisDate) : null}
          onChange={(selectedDate: Date) => handleChangeCalendar(selectedDate)}
          onCalendarOpen={handleOpenCalendar}
          onCalendarClose={handleCloseCalendar}
          isClearable={isCalendarOpened}
          calendarStartDay={1}
          locale={targetLang}
          inline={isMobile && isCalendarOpened}
          filterDate={scheduleCalendarFilter}
          renderDayContents={CalendarDayContent}
          minDate={new Date()}
          showPopperArrow={false}
          renderCustomHeader={(data) => (
            <BookingCalendarHeader
              date={data.date}
              changeMonth={data.changeMonth}
              decreaseMonth={data.decreaseMonth}
              increaseMonth={data.increaseMonth}
              prevMonthButtonDisabled={data.prevMonthButtonDisabled}
              nextMonthButtonDisabled={data.nextMonthButtonDisabled}
            />
          )}
        />
      </div>
    </ErrorBoundary>
  )
}

export default BookingCalendar
